"use client";

import { TableRow, TableCell, Skeleton, Avatar } from "@/ui";
import Quantum from "@components/shared/loading/QuantumLoader";
import Link from "next/link";
import isPlaceholderPhoto from "@lib/candidates/isPlaceholderPhoto";

export default function ImportingRow({ candidate }) {
  return (
    <TableRow>
      <TableCell>
        <Avatar
          src={isPlaceholderPhoto(candidate.photo_url) ? undefined : candidate.photo_url}
          name={candidate.name}
          size="sm"
        />
      </TableCell>
      <TableCell>
        <div>
          <Link href={`/candidates/${candidate.uuid}`} style={{ fontWeight: 500, fontSize: 13 }}>{candidate.name}</Link>
          {candidate.position_title && (
            <div style={{ fontSize: 12, color: "var(--text-secondary, #6b7280)", marginTop: 2 }}>{candidate.position_title}</div>
          )}
        </div>
      </TableCell>
      <TableCell><Skeleton width={140} height={13} /></TableCell>
      <TableCell><Skeleton width={70} height={13} /></TableCell>
      <TableCell style={{ textAlign: "right" }}><Quantum size="18" /></TableCell>
    </TableRow>
  );
}
